const subscribeBtnsList = document.querySelectorAll(
  ".product-cards .subscribe-button"
);
const flavorSelector = document.querySelector("#flavorSelector");
const flavorBtnsList = document.querySelectorAll("#flavorSelector .choice");
const popupContainer = document.querySelector("#popupContainer");
const popupDurationText = document.querySelector("#popupDuration");
const popupPrice = document.querySelector("#popupPrice");
const btnClosePopup = document.querySelector("#btnClosePopup");
const atcFormVariantSelector = document.querySelector(
  "#atcFormVariantSelector"
);
const skipLimitInputEl = document.querySelector("#skipLimit");
const variantsData = window.subscriptionSectionVariantsData;

let s_ProductId = 0;
let s_CurrentSubscriptionType = "";
let s_CurrentFlavor = "";
let s_SkipLimit = 0;
let s_SelectedVariant = undefined;
let s_WidgetWasCreated = false;
let s_WidgetReturnValue = undefined;
let s_ModalIsOpen = false;

function updateSkipLimit(value) {
    switch (value) {
      case "sub rolling":
        s_SkipLimit = 0;
        break;
      case "sub 6mo":
        s_SkipLimit = 1;
        break;
      case "sub 12mo":
        s_SkipLimit = 2;
        break;
      default:
        console.warn("s_CurrentSubscriptionType variable value is wrong");
    }
    skipLimitInputEl.value = s_SkipLimit;
}

function updateUrlParams() {
  // Update URL and add to browser history
  let newUrl = new URL(window.location.href);              
  newUrl.searchParams.set("variant", s_SelectedVariant.id);
  // newUrl.searchParams.set("selling_plan", sellingPlan);
  window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
}

for (const btn of subscribeBtnsList) {
  btn.addEventListener("click", () => {
    s_ProductId = parseInt(btn.dataset.productid);
    s_CurrentSubscriptionType = btn.dataset.subscriptiontype;
    updateSkipLimit(s_CurrentSubscriptionType);
    // If no s_CurrentFlavor value, use default from section settings
    if (s_CurrentFlavor == "") {
      s_CurrentFlavor = btn.dataset.defaultflavor;
    }
    // Select Flavor
    let flavorItemToSelect = flavorSelector.querySelector(
      `[data-flavor="${s_CurrentFlavor}"]`
    );
    // Update Views
    let durationText;
    if(s_CurrentSubscriptionType === 'sub rolling') {
      durationText = 'Monthly rolling'
    } else if(s_CurrentSubscriptionType === 'sub 12mo') {
      durationText = '12 month'
    }
    popupDurationText.innerHTML = durationText;
    popupPrice.innerHTML = btn.dataset.price;
    updateFlavor(flavorItemToSelect);
    updateSelectedVariant();
    // Unhide Popup
    // popupContainer.classList.remove("d-none");
    toggleFlavorModal();
  });
}

btnClosePopup.addEventListener("click", () => {
  // popupContainer.classList.add("d-none");
  toggleFlavorModal();
});
popupContainer.addEventListener("click", (e) => {
  if (e.target !== e.currentTarget) {
    return;
  }
  // popupContainer.classList.add("d-none");
  toggleFlavorModal();
});

for (const flavor of flavorBtnsList) {
  flavor.addEventListener("click", (e) => {
    updateFlavor(e.currentTarget);
    updateSelectedVariant();
  });
}

function updateFlavor(el) {
  for (const flavor of flavorBtnsList) {
    flavor.classList.remove("selected");
  }
  el.classList.add("selected");
  s_CurrentFlavor = el.dataset.flavor;
}

function updateSelectedVariant() {
  if (s_CurrentSubscriptionType == "" || s_CurrentFlavor == "") {
    console.warn("Data is missing!");
  } else {
    // use s_CurrentSubscriptionType and s_CurrentFlavor to find the variant id
    s_SelectedVariant = variantsData.find((item) => {
      return (
        item.flavor === s_CurrentFlavor && item.plan == s_CurrentSubscriptionType
      );
    });
    createRechargeWidget();
    // Select the variant in the form & trigger change event manually to update widget
    atcFormVariantSelector.value = s_SelectedVariant.id;
    let changeEvent = new Event("change");
    atcFormVariantSelector.dispatchEvent(changeEvent);
    updateUrlParams();
  }
}

function createRechargeWidget() {
  if (!s_WidgetWasCreated) {
    s_WidgetReturnValue = window.ReChargeWidget.createWidget({
      productId: s_ProductId,
      selectors: {
        variant: ["#atcFormVariantSelector"],
        price: ["#rechargeVariantPrice"],
      },
    });
    if (s_WidgetReturnValue) {
      s_WidgetWasCreated = true;
    } else {
      //console.log("Too early to create widget");
    }
  }
}

function toggleFlavorModal() {
  if (!s_ModalIsOpen) {
    popupContainer.setAttribute("open", true);
    s_ModalIsOpen = true;
  } else {
    if (!popupContainer.hasAttribute('closing')) {
      popupContainer.removeAttribute("open");
      popupContainer.setAttribute("closing", true);
      popupContainer.addEventListener('animationend', () => {
        popupContainer.removeAttribute("closing");
        s_ModalIsOpen = false;
      }, {once: true})
    }
  }
}

// If window.updVarOnload exists, update the variant in the URL (for Google Analytics view_item event)
let updVarOnload = window.updVarOnload;
if (updVarOnload) {
  let varToRegister = variantsData.find((item) => {
    return (
      item.flavor === updVarOnload.flavor && item.plan == updVarOnload.duration
    );
  });

  let newUrl = new URL(window.location.href);              
  newUrl.searchParams.set("variant", varToRegister.id);
  window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
}